module.exports = __webpack_public_path__ + "img/glassquality_6.395ca7b3.png";